import React from "react";
import { Lock } from "lucide-react";

/**
 * InternalBadge — subtle "INTERNAL" industrial tag for projects flagged
 * as internal-development-only (unsanitized plans, never publicly shared).
 *
 * Visual intent (per directive): restrained operational tag, not a warning
 * banner. Sits in a top-corner of cards/headers and reads as part of the
 * tooling, not an alert.
 */
export default function InternalBadge({ size = "sm", className = "", ...rest }) {
  const sz = size === "xs"
    ? { px: "px-1.5", py: "py-[1px]", text: "text-[8px]", icon: 8, gap: "gap-1" }
    : size === "md"
    ? { px: "px-2", py: "py-0.5", text: "text-[10px]", icon: 10, gap: "gap-1.5" }
    : { px: "px-1.5", py: "py-0.5", text: "text-[9px]", icon: 9, gap: "gap-1" };
  return (
    <span
      className={`inline-flex items-center ${sz.gap} ${sz.px} ${sz.py} rounded ${sz.text} font-mono uppercase tracking-[0.2em] border border-[rgba(232, 93, 31,0.35)] bg-[rgba(232, 93, 31,0.08)] text-[var(--fop-primary)] ${className}`}
      title="Internal-only project — unsanitized plans, blocked from public share links"
      data-testid="internal-badge"
      {...rest}
    >
      <Lock size={sz.icon} strokeWidth={2.4} />
      Internal
    </span>
  );
}
